import { isBefore } from 'date-fns';

import { Defect } from '@/types/Defecten';
import { LocatieVoorEenheden } from '@/types/LocatieVoorEenheden';
import { dagEnMaandEnJaarDatum, tijdstipDatum } from '@/utils/dateUtils';

/** Bepaal of een defect binnen x uur niet meer inzetbaar is. Als een defect op basis van tijd al niet meer inzetbaar is, returned de functie dus false.
 *
 * @param defect
 * @param periodeUren
 * @returns
 */
export const defectIsBinnenPeriodeNietInzetbaar = (defect: Defect, periodeUren = 12): boolean => {
  const { nietMeerInzetbaarVanaf } = defect;
  if (nietMeerInzetbaarVanaf === null) return false;
  const inzetbaarUren = (new Date(nietMeerInzetbaarVanaf).getTime() - Date.now()) / (1000 * 3600);
  return inzetbaarUren >= 0 && inzetbaarUren <= periodeUren;
};

/** A defect needs to be fixed when it has soort DEFECT_NIET_INZETBAAR, but is still inzetbaar.
 *
 * @param defect
 * @returns
 */
export const fixDefect = (defect: Defect): Defect => {
  // Een defect dat al voor nietMeerInzetbaarVanaf is begonnen (ntqpricode 1) is bewust niet inzetbaar en mag niet gecorrigeerd worden.
  // De periode van 48 uur is dezelfde als waarmee we de defecten initieel ophalen.
  const isBewustNietInzetbaar =
    !!defect.beginTijd &&
    !!defect.nietMeerInzetbaarVanaf &&
    new Date(defect.beginTijd).getTime() < new Date(defect.nietMeerInzetbaarVanaf).getTime();
  if (
    defect.soort !== 'DEFECT_NIET_INZETBAAR' ||
    !defectIsBinnenPeriodeNietInzetbaar(defect, 48) ||
    isBewustNietInzetbaar
  )
    return defect;
  return { ...defect, soort: defect.verplaatsingsBeperking ? 'BEPERKING_IN_TREINDIENST' : 'GEEN_BEPERKINGEN' };
};

/** Parses the numeric speed value from a speed restriction string (e.g. "140 km/h" → 140).
 *  Returns Infinity when no number is found, so items without a restriction sort last.
 */
export const parseSnelheid = (snelheid: string): number => {
  const match = /\d+/.exec(snelheid);
  return match ? Number.parseInt(match[0], 10) : Infinity;
};

// Wanneer het defectsoort DEFECT_NIET_INZETBAAR is, of wanneer 'nietMeerInzetbaarVanaf' al verlopen is, moet het defect in de NIET_INZETBAAR-kolom geplaatst worden
export const defectTypeNietInzetbaar = (defect?: Defect): boolean => {
  return (
    !!defect &&
    (defect.soort === 'DEFECT_NIET_INZETBAAR' ||
      (!!defect.nietMeerInzetbaarVanaf && isBefore(new Date(defect.nietMeerInzetbaarVanaf), new Date())))
  );
};

/** Laat de juiste title zien bij de locatie van het defect */
export const titleVoorLocatie = (locatieVoorEenheden: LocatieVoorEenheden) => {
  const date = new Date(locatieVoorEenheden.tijd);
  if (!locatieVoorEenheden.stilstaande) {
    return `Locatie om ${tijdstipDatum(date)}`;
  }
  return `Locatie op ${dagEnMaandEnJaarDatum(date)} ${tijdstipDatum(date)}`;
};
